import { render } from "./NarrativeHome.vue?vue&type=template&id=029ecad2&scoped=true"
import script from "./NarrativeHome.vue?vue&type=script&lang=js"
export * from "./NarrativeHome.vue?vue&type=script&lang=js"

import "./NarrativeHome.vue?vue&type=style&index=0&id=029ecad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029ecad2"]])

export default __exports__